import { Box, styled } from "@mui/material";

const BLOG_IMAGE_CONTENT_PREFIX = "BlogImageContent";

export const blogImageContentClasses = {
  root: `${BLOG_IMAGE_CONTENT_PREFIX}-root`,
  heading: `${BLOG_IMAGE_CONTENT_PREFIX}-heading`,
  image: `${BLOG_IMAGE_CONTENT_PREFIX}-image`,
  copyright: `${BLOG_IMAGE_CONTENT_PREFIX}-copyright`,
};

export const StyledBlogImageContent = styled(Box)(({ theme }) => ({
  [`&.${blogImageContentClasses.root}`]: {
    marginBottom: "48px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    [`& .${blogImageContentClasses.heading}`]: {
      color: "#0F2F4B",
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "15px",
      textAlign: "left",
      width: "100%",
    },
    [`& .${blogImageContentClasses.image}`]: {
      width: "100%",
      maxWidth: "100%",
      height: "auto",
      borderRadius: "8px",
      display: "block",
    },
    [`& .${blogImageContentClasses.copyright}`]: {
      marginTop: "12px",
      fontSize: "14px",
      color: "#666",
      fontStyle: "italic",
      textAlign: "left",
    },
  },
}));

